import { findTargetLinear } from './findTargetLinear'
import { findTargetLog } from './findTargetLog'

export const findTarget = (
	num1: number,
	num2: number,
	axis: number,
	isLong: boolean,
	isLog: boolean,
): number => {
	return isLog
		? findTargetLog(num1, num2, axis, isLong)
		: findTargetLinear(num1, num2, axis, isLong)
}
